var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.count),function(c,key){return _c('div',{key:key},[_c('div',{staticClass:"taskList"},[_c('taskList',{ref:"taskList",refInFor:true,attrs:{"reportNum":_vm.reportNum,"c":c}})],1)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }